import getLibraryItemInfo from '@/requests/library/getLibraryItemInfo';

/**
 * Shared React Query options for loading a preset by slug (the
 * `['libraryItemInfo', slug]` cache the feed, its mutation, and the deeplink
 * handler all read). Throws on null so a failed load caches as an *error*
 * (which refetches on next access) rather than a sticky `null` that would flow
 * into `buildInputsFromPreset`. Pass to `queryClient.fetchQuery(...)`.
 *
 * Not for existence checks — `useLibraryItemQuery` keeps its own non-throwing
 * query (returns null on failure) for that.
 */
const libraryItemInfoQueryOptions = (slug: string) => ({
  queryKey: ['libraryItemInfo', slug],
  queryFn: async () => {
    const data = await getLibraryItemInfo(slug);
    if (!data) throw new Error('Failed to load library item');
    return data;
  },
});

export default libraryItemInfoQueryOptions;
